<template>
    <div class="reportlist">
        <header>
            <el-form>
                <el-form-item>
                    学号：<el-input type="text" v-model="params.testerID" clearable placeholder="请输入学号" style="width: auto;"></el-input>
                </el-form-item>
                <el-form-item>
                    姓名：<el-input type="text" v-model="params.searchValue" clearable placeholder="请输入姓名" style="width: auto;"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="query">查询</el-button>
                    <el-button @click="reset">重置</el-button>
                </el-form-item>
            </el-form>
        </header>
        <main>
            <el-table
            v-loading="loading"
            element-loading-text="拼命加载中"
            :data="reportlist"
            style="width: 100%">
            <el-table-column label="序号">
                <template slot-scope="scope">
                    {{ (params.pageNum - 1) * 10 + scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="userId" label="学号"></el-table-column>
            <el-table-column prop="realName" label="姓名"></el-table-column>
            <el-table-column prop="sex" label="性别"></el-table-column>
            <el-table-column prop="birthday" label="出生日期"></el-table-column>
            <el-table-column prop="testTime" label="测试日期"></el-table-column>
            <el-table-column prop="deptName" label="用户所属"></el-table-column>
            <el-table-column prop="publishSubject" label="训练项目"></el-table-column>
            <el-table-column prop="testReport" label="测试类型"></el-table-column>
            <el-table-column prop="startTime"  label="开始时间"></el-table-column>
            <el-table-column prop="endTime" label="结束时间"></el-table-column>
            <el-table-column label="操作">
                <template v-slot="scope">
                    <el-button type="text" @click="$router.push('/biofeedback/report?biofeedbackId='+scope.row.biofeedbackID)">查看报告</el-button>
                </template>
            </el-table-column>
            </el-table>
            <el-pagination
                hide-on-single-page
                @current-change="handleCurrentChange"
                :current-page.sync="params.pageNum"
                :page-size="params.pageSize"
                layout="total, prev, pager, next"
                :total="params.pageTotal">
            </el-pagination>
        </main>
    </div>
</template>
<script>
export default{
    data() {
        return {
            loading:true,
            params:{
                pageNum:1,
                pageSize:10,
                pageTotal:0,
                testerID:null,
                searchValue:''
            },
            reportlist: []
        }
    },
    mounted() {
        this.query()
    },
    methods: {
        // 查询
        query(){
            this.$Http_Post('bioassay/biofeedbackResult/list',this.params).then(res=>{
                if(res.Code==0){
                    this.reportlist=res.Data;
                    this.loading=false;
                    this.params.pageTotal=res.Counts;
                }else{
                    this.$message({ message: res.Message, type: 'error'});
                }
            })
        },
        handleCurrentChange(val){
            this.params.pageNum=val;
            this.query();
        },
        // 重置
        reset(){
            this.params=this.$options.data().params;
            this.query();
        }
    },
}
</script>
<style scoped>
.reportlist header{background: #fff;padding:20px;margin-bottom: 20px;}
.reportlist main{background: #fff;padding:20px;}
.reportlist .el-form-item{margin:0 20px 0 0;display: inline-flex;}
</style>